export default function ModalEditSportzcast(
  sportzcast,
  Account,
  $rootScope,
  toaster,
  $uibModalInstance
) {
  'ngInject';

  const { account } = $rootScope;

  // passed in via `resolve`
  this.sportzcast = angular.copy(sportzcast);

  this.cancel = () => $uibModalInstance.dismiss();

  this.limits = $rootScope.ApiConfig.modelFieldLimits('sportzcast_integration', 'maximum');

  this.showChangePassword = false;
  this.previouslyEnabledSportzcast = !!sportzcast.username;
  this.passwordConfirm = '';

  this.update = () => {
    // SportzCast validation
    let data = { username: this.sportzcast.username };
    if (!data.username) {
      toaster.pop('warning', 'SportzCast username is required');
      return;
    }
    if (!this.previouslyEnabledSportzcast || this.showChangePassword) {
      if (!this.sportzcast.password) {
        toaster.pop('warning', 'SportzCast password is required');
        return;
      }
      if (this.sportzcast.password != this.passwordConfirm) {
        toaster.pop('warning', 'SportzCast passwords do not match');
        return;
      }
      data.password = this.sportzcast.password;
    }

    // Update common scoreboard settings separate from SportzCast
    this.submitting = true;
    Account.updateSportzcast({ id: account.id }, data)
      .$promise.then((r) => {
        $uibModalInstance.close(r);
      })
      .catch((err) => {
        console.error(e);
        toaster.pop(
          'warning',
          'Unable to save Sportzcast configuration. Please refresh and try again.'
        );
        this.submitting = false;
      });
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-edit-sportzcast.js